const Auth = {
  Login: '/login',
  Verify: '/verify',
  Signup: '/sign-up',
  ForgotPassword: '/forgot-password',
  ChangePassword: '/change-password',
};

const Dashboard = {
  Home: '/dashboard',
};

const ContactUs = {
  Home: '/contact-us',
};

const Profile = {
  Home: '/profile',
};

const AdditionalInfo = {
  Home: '/additional-info',
};

const NotFound = '/not-found';

const Course = {
  Form: '/forms/:id',
  Resource: '/resources/:id',
};

const Resources = {
  Home: '/resources',
};

export const Routes = {
  Auth,
  Course,
  Profile,
  NotFound,
  Home: '/',
  Dashboard,
  ContactUs,
  Resources,
  AdditionalInfo,
};
